import { RequestDocumentDto } from './request-documents.dto';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class RequestManagementDto extends EpimsBaseEntityDto {
  RequestManagementId: string;
  RequestorName: string;
  RequestorEmail: string;
  ResponseDate: string;
  OnbehalfName: string;
  RequestCategoryId: string;
  RequestDescription: string;
  Documents: RequestDocumentDto[];
  DocUrl: string;
  DocName: string;
  OnbehalfId: string;
  Request: string;
  Remark: string;
  RequestStatus: string;
  SubscriberId: string;
  SubscriptionUserId: string;
}
